import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { guestHouseService } from "../services/guestHouseService";

import image4 from "../assets/images/4.png"; // Fallback image
import "../styles/guesthouselist.css"; // Import your CSS styles
import { Link } from "react-router-dom";
import bookingService from "../services/bookingService";
import { formatDateTime } from "../utility/utility";
const Dashboard = () => {
  const [guestHouses, setGuestHouses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [todayBookings, setTodayBookings] = useState([]);
  const [upcomingBookings, setUpcomingBookings] = useState([]);
  const { protocol, hostname, port } = window.location;
  const portSuffix = port ? `:${port}` : "";
  const trailingSlash = "/";

  const domain = `${protocol}//${hostname}${portSuffix}${trailingSlash}assets`;

  useEffect(() => {
    const fetchGuestHouses = async () => {
      try {
        setLoading(true);
        setError(null);

        // Call the API using our service
        const data = await guestHouseService.getGuestHouseList(true);

        setGuestHouses(data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching guest houses:", error);
        setError(error.message || "Failed to load guest houses");
        setLoading(false);
      }
    };

    const fetchTodayBookings = async () => {
      try {
        // Get today's date in the format expected by the API
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
        const day = String(today.getDate()).padStart(2, "0");
        const formattedLocalDate = `${year}-${month}-${day}`;
        console.log(formattedLocalDate);

        // Fetch bookings for today
        const bookings = await bookingService.getBookings({
          startDate: formattedLocalDate,
          endDate: formattedLocalDate,
        });

        setTodayBookings(bookings);
      } catch (error) {
        console.error("Error fetching today's bookings:", error);
      }
    };

    const fetchUpcomingBookings = async () => {
      try {
        // Get today's date
        const nextDay = new Date();
        nextDay.setDate(nextDay.getDate() + 1);
        // Get date 7 days from now
        const sevenDaysLater = new Date();
        sevenDaysLater.setDate(nextDay.getDate() + 6);

        // Format dates as expected by the API (using local time)
        const startYear = nextDay.getFullYear();
        const startMonth = String(nextDay.getMonth() + 1).padStart(2, "0");
        const startDay = String(nextDay.getDate()).padStart(2, "0");
        const startDate = `${startYear}-${startMonth}-${startDay}`;

        const endYear = sevenDaysLater.getFullYear();
        const endMonth = String(sevenDaysLater.getMonth() + 1).padStart(2, "0");
        const endDay = String(sevenDaysLater.getDate()).padStart(2, "0");
        const endDate = `${endYear}-${endMonth}-${endDay}`;

        // Fetch bookings for the next 7 days
        const bookings = await bookingService.getBookings({
          startDate: startDate,
          endDate: endDate,
        });

        setUpcomingBookings(bookings);
      } catch (error) {
        console.error("Error fetching upcoming bookings:", error);
      }
    };
    fetchGuestHouses();
    fetchTodayBookings();
    fetchUpcomingBookings();
  }, []);

  // Filter active bookings for counting
  const activeTodayBookings = todayBookings.filter(
    (booking) => booking.IsCancelled === "0" || booking.IsCancelled === 0
  );
  const activeUpcomingBookings = upcomingBookings.filter(
    (booking) => booking.IsCancelled === "0" || booking.IsCancelled === 0
  );

  return (
    <div className="main-container">
      <Navbar />
      <div style={{ height: "15px" }}></div>

      <main className="container-fluid">
        <div className="row">
          <div style={{ fontSize: "20px", color: "#514e4e" }}>
            Welcome to Dashboard
          </div>
          <div style={{ height: "15px" }}></div>
          {guestHouses &&
            guestHouses.length > 0 &&
            guestHouses.map((guestHouse, key) => {
              const address = `${guestHouse.address} ${guestHouse.city} ${
                guestHouse.state || ""
              }`;
              return (
                <div className="col-lg-3" key={key}>
                  <div className="d-flex guest-house-card">
                    <div className="row g-0">
                      <div
                        className="col-md-12"
                        style={{ position: "relative" }}
                      >
                        <img
                          src={
                            guestHouse.baseImage
                              ? domain + guestHouse.baseImage
                              : image4
                          }
                          alt="ONGC Guest House Noida"
                          className="guest-house-image"
                        />

                        {/* Location icon positioned at bottom right */}
                        <div
                          style={{
                            position: "absolute",
                            bottom: "10px",
                            right: "10px",
                            backgroundColor: "rgb(255, 255, 255)",
                            borderRadius: "50%",
                            width: "32px",
                            height: "32px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                          }}
                        >
                          <a
                            href={guestHouse.directionUrl}
                            target="_blank"
                            className="direction-link"
                          >
                            <i
                              className="fa fa-paper-plane"
                              style={{
                                color: "#rgb(53, 171, 229)",
                                fontSize: "18px",
                              }}
                            ></i>
                          </a>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="guest-house-details">
                          Available Rooms :{" "}
                          <span style={{ color: "#3abd3a", fontSize: "22px" }}>
                            {guestHouse.totalRooms -
                              guestHouse.occupiedRegularRooms +
                              (guestHouse.suites -
                                guestHouse.occupiedSuiteRooms)}
                          </span>
                          <span style={{ fontSize: "22px" }}>
                            /{guestHouse.totalRooms + guestHouse.suites}{" "}
                          </span>
                          <h2 className="guest-house-title">
                            {guestHouse.guestHouseName}
                          </h2>
                          <p className="guest-house-info">
                            {guestHouse.suites > 0 && (
                              <span className="suites-info">
                                <strong>{guestHouse.suites}</strong> Suites,
                              </span>
                            )}
                            <strong>{guestHouse.totalRooms}</strong> Rooms
                          </p>
                          <p className="guest-house-location">
                            <i
                              className="fa fa-location-dot"
                              style={{
                                color: "#rgb(53, 171, 229)",
                                fontSize: "14px",
                              }}
                            ></i>{" "}
                            {address}
                          </p>
                          <p className="guest-house-location">
                            <i
                              className="fa fa-phone-volume"
                              style={{
                                color: "#rgb(53, 171, 229)",
                                fontSize: "14px",
                              }}
                            ></i>{" "}
                            {guestHouse.additional_tx}
                          </p>
                          {/* <a href="#" className="btn book-now-btn">Book Now</a> 
                          <Link
                            to={`/guest-house/${guestHouse.id}`}
                            className="book-now-btn mt-3"
                          >
                            Book Now
                          </Link>*/}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          
        </div>
        <div>
          <div className="row">
            {/* Left Card: Today's Bookings */}
            <div className="col-md-6 mb-5">
              <div className="card shadow-sm" style={{ height: "400px" }}>
                 {/* h-100 */}
                <div className="card-body" style={{ padding: "0px" }}>
                  <h2
                    className="card-title fw-semibold mb-3"
                    style={{
                      fontSize: "18px",
                      fontWeight: 700,
                      paddingTop: "26px",
                      paddingLeft: "18px",
                      color: "#007AFF",
                    }}
                  >
                    Today's Bookings
                  </h2>

                  <div
                    className="table-responsive"
                    style={{ 
                      borderRadius: "0px",
                      maxHeight: activeTodayBookings.length > 10 ? "280px" : "auto",
                      overflowY: activeTodayBookings.length > 10 ? "auto" : "visible",
                      overflowX: "hidden"
                    }}
                  >
                    <table
                      className="table table-hover small"
                      style={{ fontSize: "13px" }}
                    >
                      <thead className="bg-dark" style={{ position: "sticky", top: "0", zIndex: 1 }}>
                        <tr className="text-left">
                          <th
                            className="py-2"
                            style={{
                              backgroundColor: "#F7F7F7",
                              color: "black",
                              width: "82px",
                              paddingLeft: "20px",
                            }}
                          >
                            Booking ID
                          </th>
                          <th
                            className="py-2"
                            style={{
                              backgroundColor: "#F7F7F7",
                              color: "black",
                              width: "100px",
                              paddingleft: "20px",
                            }}
                          >
                            Guest Name
                          </th>
                          <th
                            className="py-2"
                            style={{
                              backgroundColor: "#F7F7F7",
                              color: "black",
                              width: "90px",
                              paddingleft: "20px",
                            }}
                          >
                            Property
                          </th>
                          <th
                            className="py-2"
                            style={{
                              backgroundColor: "#F7F7F7",
                              color: "black",
                              width: "30px",
                              paddingleft: "20px",
                            }}
                          >
                            Rooms
                          </th>
                          <th
                            className="py-2"
                            style={{
                              backgroundColor: "#F7F7F7",
                              color: "black",
                              width: "90px",
                              paddingleft: "20px",
                            }}
                          >
                            Check-in
                          </th>
                          <th
                            className="py-2"
                            style={{
                              backgroundColor: "#F7F7F7",
                              color: "black",
                              width: "90px",
                              paddingleft: "20px",
                            }}
                          >
                            Check-out
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {todayBookings.map(
                          (booking) =>
                            (booking.IsCancelled === "0" ||
                              booking.IsCancelled === 0) && (
                              <tr
                                key={booking.BookingID}
                                className="border-t"
                                style={{ color: "#D9D9D9" }}
                              >
                                <td
                                  className="py-2"
                                  style={{ width: "80px", paddingLeft: "20px" }}
                                >
                                  {booking.CustomBookingID || booking.BookingID}
                                </td>
                                <td className="py-2">
                                  {booking.guestName || booking.GuestName}
                                </td>
                                <td className="py-2">
                                  {booking.guestHouseName || booking.GuestHouseName}
                                </td>
                                <td className="py-2">
                                  {parseInt(booking.NoOfRooms) +
                                    parseInt(booking.NoOfSuitesRooms)}
                                </td>
                                <td className="py-2">
                                  {formatDateTime(
                                    booking.checkInDate || booking.CheckInDate
                                  )}
                                </td>
                                <td className="py-2">
                                  {formatDateTime(
                                    booking.checkOutDate || booking.CheckOutDate
                                  )}
                                </td>
                              </tr>
                            )
                        )}
                      </tbody>
                    </table>
                  </div>

                  <div className="position-absolute bottom-0 end-0 pb-2 pe-3">
                    <Link
                      to={`/viewbookings`}
                      className="btn btn-link text-primary"
                      style={{
                        fontSize: "14px",
                        fontWeight: "500",
                      }}
                    >
                      View All Bookings
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Card: Upcoming 7 days check-in */}
            <div className="col-md-6 mb-5">
              <div className="card shadow-sm " style={{ height: "400px" }}>
                {/* h-100 */}
                <div className="card-body" style={{ padding: "0px" }}>
                  <h2
                    className="card-title fw-semibold mb-3"
                    style={{
                      fontSize: "18px",
                      fontWeight: 700,
                      paddingTop: "26px",
                      paddingLeft: "18px",
                      color: "#007AFF",
                    }}
                  >
                    Upcoming 7 days check-in
                  </h2>

                  <div
                    className="table-responsive"
                    style={{ 
                      borderRadius: "0px",
                      maxHeight: activeUpcomingBookings.length > 10 ? "280px" : "auto",
                      overflowY: activeUpcomingBookings.length > 10 ? "auto" : "visible",
                      overflowX: "hidden"
                    }}
                  >
                    <table
                      className="table table-hover small"
                      style={{ fontSize: "13px" }}
                    >
                      <thead style={{ position: "sticky", top: "0", zIndex: 1 }}>
                        <tr className="text-left">
                          <th
                            className="py-2"
                            style={{
                              backgroundColor: "#F7F7F7",
                              color: "black",
                              width: "82px",
                              paddingLeft: "20px",
                            }}
                          >
                            Booking ID
                          </th>
                          <th
                            className="py-2"
                            style={{
                              backgroundColor: "#F7F7F7",
                              color: "black",
                              width: "100px",
                              paddingleft: "20px",
                            }}
                          >
                            Guest Name
                          </th>
                          <th
                            className="py-2"
                            style={{
                              backgroundColor: "#F7F7F7",
                              color: "black",
                              width: "90px",
                              paddingleft: "20px",
                            }}
                          >
                            Property
                          </th>
                          <th
                            className="py-2"
                            style={{
                              backgroundColor: "#F7F7F7",
                              color: "black",
                              width: "30px",
                              paddingleft: "20px",
                            }}
                          >
                            Rooms
                          </th>
                          <th
                            className="py-2"
                            style={{
                              backgroundColor: "#F7F7F7",
                              color: "black",
                              width: "90px",
                              paddingleft: "20px",
                            }}
                          >
                            Check-in
                          </th>
                          <th
                            className="py-2"
                            style={{
                              backgroundColor: "#F7F7F7",
                              color: "black",
                              width: "90px",
                              paddingleft: "20px",
                            }}
                          >
                            Check-out
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {upcomingBookings.map(
                          (booking) =>
                            (booking.IsCancelled === "0" ||
                              booking.IsCancelled === 0) && (
                              <tr key={booking.BookingID} className="border-t">
                                <td
                                  className="py-2"
                                  style={{ width: "80px", paddingLeft: "20px" }}
                                >
                                  {booking.CustomBookingID || booking.BookingID}
                                </td>
                                <td className="py-2">
                                  {booking.guestName || booking.GuestName}
                                </td>
                                <td className="py-2">
                                  {booking.guestHouseName || booking.GuestHouseName}
                                </td>
                                <td className="py-2">
                                  {parseInt(booking.NoOfRooms) +
                                    parseInt(booking.NoOfSuitesRooms)}
                                </td>
                                <td className="py-2">
                                  {formatDateTime(
                                    booking.checkInDate || booking.CheckInDate
                                  )}
                                </td>
                                <td className="py-2">
                                  {formatDateTime(
                                    booking.checkOutDate || booking.CheckOutDate
                                  )}
                                </td>
                              </tr>
                            )
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
       
      </main>

      <Footer />
    </div>
  );
};

export default Dashboard;